import { useConfig } from '@/composables';
import { MANITOBA_BBOX } from '@/features';
import axios, { AxiosError } from 'axios';
import { GeocodingResponseModel } from '../models/geocoding-model';
const config = useConfig();

// TODO: extract to config
const mapboxAxios = axios.create({
  baseURL: 'https://api.mapbox.com/search/geocode/v6/',
});

export class MapboxDataSource {
  async getForwardGeocoding(searchTerm: string) {
    try {
      const response = await mapboxAxios.get<GeocodingResponseModel>('forward', {
        params: {
          q: searchTerm,
          access_token: config.value.mapbox.token,
          country: 'ca',
          types: ['place', 'locality', 'neighborhood', 'street', 'address'],
          bbox: MANITOBA_BBOX,
          autocomplete: true,
          limit: 10,
        },
      });

      return response.data;
    } catch (e) {
      throw new Error((e as AxiosError).code);
    }
  }

  async getReverseGeocoding(latitude: number, longitude: number) {
    try {
      const response = await mapboxAxios.get<GeocodingResponseModel>('reverse', {
        params: {
          latitude,
          longitude,
          access_token: config.value.mapbox.token,
          // NOTE: This means (devs) not in CA will not be able to use this feature.
          country: 'ca',
          types: ['street', 'address'],
        },
      });

      return response.data;
    } catch (e) {
      throw new Error((e as AxiosError).code);
    }
  }
}
